import { render, staticRenderFns } from "./AddApparatusUpgradeSubscription.vue?vue&type=template&id=67380d0b"
import script from "./AddApparatusUpgradeSubscription.vue?vue&type=script&lang=js"
export * from "./AddApparatusUpgradeSubscription.vue?vue&type=script&lang=js"
import style0 from "./AddApparatusUpgradeSubscription.vue?vue&type=style&index=0&id=67380d0b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports